$(document).ready(function() {
  $('.contact-setting-tab').on('click', function() {
    location.hash = $(this).attr('href')
  })

  $('.contact-setting-document-field .contact-setting-document')
    .blur(function() {
      const $el = $('.contact-setting-document-field .contact-setting-cache-document')
      if ($el.length) {
        $el.remove()
        $('.contact-setting-document-field .file-path').val('')
      }
    })
    .on('direct-upload:error', function(e) {
      e.preventDefault()

      M.toast({
        html: 'ファイルのアップロードに失敗しました。ページを更新してください。',
        displayLength: 'stay',
      })
    })
})
